import { Box, CircularProgress, Stack, Typography, alpha } from '@mui/material';
import { CRM_PALETTE as P } from '../../../theme/brandPalette';

/**
 * LO QUE SE VE MIENTRAS BAJA EL HILO. (25/08/2026, pedido del user)
 *
 * Antes el widget mostraba una caja vacía: el modal quedaba en blanco unos segundos y no
 * había forma de distinguir "está cargando" de "se perdió la conversación". Es el momento en
 * que más se nota, porque es lo primero que pasa al abrir.
 *
 * Ocupa el alto entero a propósito —y no un spinner chico arriba—: mientras carga no hay
 * nada más en pantalla, y un punto suelto en una esquina se lee como que algo falló.
 */
export function CargandoHilo({ texto = 'Cargando tu conversación…' }: { texto?: string }) {
  const golden = P.brand.golden;
  return (
    <Box sx={{
      height: '100%', minHeight: 180,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
    }}>
      <Stack spacing={1.25} alignItems="center">
        <CircularProgress size={26} sx={{ color: golden }} />
        <Typography sx={{ fontSize: 12, color: alpha('#F0EDE6', 0.6) }}>{texto}</Typography>
      </Stack>
    </Box>
  );
}
